// get the set of month names for the actiuve language
import { useActiveLangStrings } from "./use-active-lang-strings";
export var useDayNames = function () {
  var strings = useActiveLangStrings();
  var dayNames = strings.dayNames || 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday_Sunday';
  return dayNames.split('_');
};